import ChangeOrderPage from "./pages/ChangeOrderPage";
import "./styles/changeOrder.scss";

const ChangeOrder = () => {
  return <ChangeOrderPage />;
};

export default ChangeOrder;
